import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import { CheckboxView } from './view';
import * as styles from './checkbox.css';
export var Checkbox =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Checkbox, _React$Component);

  function Checkbox() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Checkbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Checkbox)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "inputRef", React.createRef());

    return _this;
  }

  _createClass(Checkbox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          checked = _this$props.checked,
          disabled = _this$props.disabled,
          tabIndex = _this$props.tabIndex,
          custom = _this$props.custom,
          __classNames = _this$props.__classNames,
          __attributes = _this$props.__attributes,
          dataMark = _this$props.dataMark,
          restProps = _objectWithoutProperties(_this$props, ["checked", "disabled", "tabIndex", "custom", "__classNames", "__attributes", "dataMark"]);

      return React.createElement("label", {
        className: __classNames
      }, React.createElement("input", _extends({}, restProps, {
        ref: this.inputRef,
        type: "checkbox",
        checked: checked,
        disabled: disabled,
        className: styles.input,
        tabIndex: tabIndex,
        "data-mark": dataMark
      }, __attributes)), React.createElement(CheckboxView, {
        checked: checked,
        disabled: disabled,
        label: custom && custom.label,
        mediaType: custom && custom.mediaType
      }));
    }
  }]);

  return Checkbox;
}(React.Component);

_defineProperty(Checkbox, "defaultProps", {
  dataMark: 'Checkbox'
});